<div class="media flash"></div>
<div class="info">
  <div class="text flash"></div>
  <div class="review flash"></div>
</div>
